import { schemaRecuperarSenha, type EntradaRecuperarSenha } from '@baiocchi/shared'
import { Alerta, Botao, Campo, Entrada } from '@baiocchi/ui'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import { autenticacaoApi } from '../../api/autenticacao'
import { useFormulario } from '../../ganchos/usar-formulario'
import { MolduraAutenticacao } from './moldura-autenticacao'

/**
 * TELA-00A — Esqueci minha senha.
 *
 * A resposta é **sempre a mesma**, exista o e-mail ou não (RN-04), e é a mensagem
 * que o servidor devolve. A tela não acrescenta "verifique se o e-mail está
 * correto" nem sinaliza sucesso de forma diferente: qualquer variação transforma
 * este formulário em um verificador de e-mails cadastrados.
 *
 * Depois de enviar, o formulário é **substituído** pela confirmação. Mantê-lo na
 * tela convidaria a reenviar, e a rota tem limite por e-mail e por IP — o segundo
 * clique viraria `429` e pareceria falha.
 */
export function PaginaEsqueciMinhaSenha() {
  const [mensagem, setMensagem] = useState<string | null>(null)

  const formulario = useFormulario<EntradaRecuperarSenha>({ email: '' })

  async function submeter(evento: React.FormEvent) {
    evento.preventDefault()
    await formulario.enviar(schemaRecuperarSenha, (valores) => valores, async (corpo) => {
      const resposta = await autenticacaoApi.recuperarSenha(corpo)
      setMensagem(resposta.mensagem)
    })
  }

  return (
    <MolduraAutenticacao
      titulo="Recuperar acesso"
      descricao={
        mensagem
          ? undefined
          : 'Informe o e-mail cadastrado. Enviaremos um link para você definir uma senha nova.'
      }
      rodape={
        <p>
          <Link to="/entrar" className="font-medium text-marca-600 underline-offset-2 hover:underline">
            Voltar para o login
          </Link>
        </p>
      }
    >
      {mensagem ? (
        <Alerta tom="sucesso" titulo="Pedido registrado">
          <p>{mensagem}</p>
          <p className="mt-2">
            O link tem validade curta e vale uma única vez. Se não chegar em alguns minutos,
            confirme com o administrador se o seu e-mail está cadastrado.
          </p>
        </Alerta>
      ) : (
        <form onSubmit={submeter} className="flex flex-col gap-4" noValidate>
          {formulario.erroGeral ? <Alerta tom="perigo">{formulario.erroGeral}</Alerta> : null}

          <Campo rotulo="E-mail" obrigatorio erro={formulario.erros.email}>
            {(atributos) => (
              <Entrada
                {...atributos}
                type="email"
                autoFocus
                autoComplete="username"
                inputMode="email"
                placeholder="nome@baiocchiimoveis.com.br"
                value={formulario.valores.email}
                temErro={atributos.temErro}
                onChange={(evento) => formulario.definir('email', evento.target.value)}
              />
            )}
          </Campo>

          <Botao type="submit" larguraTotal tamanho="lg" carregando={formulario.enviando}>
            Enviar link de recuperação
          </Botao>
        </form>
      )}
    </MolduraAutenticacao>
  )
}
